import React, { useContext, useEffect, useState } from 'react';
import { EventList } from './EventList';
import { EventShortList } from './EventShortList';
import { AppContext } from '../context/AppContext';
import Axios from 'axios';

export const EventSection = ({ list, count, isShort }) => {
  const { appState, appDispatch } = useContext(AppContext);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    window.ASC_EVENT_LOADER.filter(({ id }) => {
      return !list || id.toLowerCase() === list;
    }).forEach(({ id, url }) => {
      Axios.get(url).then(({ data }) => {
        appDispatch({
          type: 'ADD_EVENTS',
          id,
          events: data.events,
          categories: data.categories,
        });
      });
    });
  }, [appDispatch, list]);

  return (
    <div>
      {isShort ? (
        appState.eventLists.map((list) => {
          return (
            <EventShortList
              list={list}
              key={list.id}
              count={count}
              className={`asc-event-list asc-event-list-${list.id} event-list-${list.id}`}
            />
          );
        })
      ) : (
        <>
          <input
            type='text'
            placeholder='Search'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className='asc-event-search'
          />
          {appState.eventLists.map((list) => {
            return (
              <EventList
                list={list}
                key={list.id}
                searchText={searchText}
                className={`asc-event-list asc-event-list-${list.id}`}
              />
            );
          })}
        </>
      )}
    </div>
  );
};
